import React from 'react';
import { Stack, PrimaryButton, DefaultButton, Spinner } from '@fluentui/react';

interface ModalActionsProps {
    onCancel: () => void;
    onSubmit: () => void;
    isSubmitting: boolean;
    isValid: boolean;
}

export const ModalActions: React.FC<ModalActionsProps> = ({ onCancel, onSubmit, isSubmitting, isValid }) => {
    return (
        <>
            {/* Action Buttons */}
            <Stack horizontal tokens={{ childrenGap: 10 }} horizontalAlign="end">
                <DefaultButton text="Cancel" onClick={onCancel} />
                <PrimaryButton text="Create Correction" onClick={onSubmit} disabled={isSubmitting || !isValid} />
            </Stack>

            {isSubmitting && <Spinner label="Creating correction..." />}
        </>
    );
};
